import { alpha } from "@mui/material/styles";
import type { SxProps, Theme } from "@mui/material/styles";

const createWorkspacePageSx = (maxWidth: number) =>
  ({
    maxWidth,
    width: "100%",
    mx: 0,
    mr: "auto",
    minWidth: 0,
  }) as const;

export const workspacePageSx = {
  ...createWorkspacePageSx(1680),
} as const;

export const workspaceCompactPageSx = {
  ...createWorkspacePageSx(1480),
} as const;

export const workspaceWidePageSx = {
  ...createWorkspacePageSx(2200),
} as const;

export const workspaceStatusPageSx = {
  width: "100%",
  maxWidth: 760,
  mx: "auto",
  minHeight: "calc(100vh - 160px)",
  display: "grid",
  placeItems: "center",
} as const;

export const workspaceStatusPageInsetSx: SxProps<Theme> = {
  ...workspaceStatusPageSx,
  px: { xs: 1, md: 2 },
};

export const workspaceStatusDisplayTextSx: SxProps<Theme> = {
  lineHeight: 1,
  color: "text.secondary",
};

export const workspaceActionButtonSx = {
  minWidth: 168,
  fontWeight: 500,
  alignSelf: { xs: "stretch", md: "auto" },
} as const;

export const workspaceSectionHeadingSx = {
  mb: 0.5,
} as const;

export const workspaceSectionInsetSx = {
  px: { xs: 1.25, md: 1.75 },
} as const;

export const getWorkspaceHeroSx = (theme: Theme) => ({
  p: { xs: 2, md: 3 },
  borderRadius: 1,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
});

export const getWorkspaceStatusCardSx = (theme: Theme) => ({
  ...getWorkspaceHeroSx(theme),
  width: "100%",
  maxWidth: 760,
  p: { xs: 3, md: 4 },
  textAlign: "center",
  boxShadow: "none",
});

export const getWorkspaceStatusIconSx = (theme: Theme) => ({
  width: 72,
  height: 72,
  borderRadius: 1,
  display: "grid",
  placeItems: "center",
  color: theme.palette.primary.main,
  backgroundColor: alpha(theme.palette.primary.main, 0.08),
  "& svg": {
    fontSize: 36,
  },
});

export const getWorkspaceSectionSx = (theme: Theme) => ({
  p: { xs: 2, md: 3 },
  borderRadius: 1,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
});

export const getWorkspaceTableShellSx = (theme: Theme) => ({
  p: { xs: 2, md: 3 },
  borderRadius: 1,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
});

export const getWorkspaceStatusPaneSx = (
  theme: Theme,
  options?: {
    minHeight?: number;
    dashed?: boolean;
    centered?: boolean;
    padding?: { xs: number; md: number };
  },
) => ({
  minHeight: options?.minHeight ?? 220,
  display: "grid",
  placeItems: options?.centered === false ? undefined : "center",
  alignItems: options?.centered === false ? "center" : undefined,
  border: `${options?.dashed ? "1px dashed" : "1px solid"} ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  p: options?.padding ?? { xs: 2, md: 3 },
});
